import DateFnsUtils from "@date-io/date-fns";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import { isNullOrEmpty } from "../Util";

export default function BrokenElevators() {
	const [fromDate, setFromDate] = React.useState(new Date(new Date().setDate(new Date().getDate() - 90)));
	const [toDate, setToDate] = React.useState(new Date());

	const [dataset, setDataset] = React.useState([] as Array<any>);

	const getData = (ft: Date, tt: Date) => {
		fetch("Building/GetBrokenElevators", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ FromDate: ft, ToDate: tt }),
		})
			.then((x) => x.json())
			.then((x) => {
				setDataset(x);
			});
	};

	React.useEffect(() => {
		getData(fromDate, toDate);
	}, []);

	return (
		<div style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1, display: "flex", flexDirection: "column", maxHeight: "100%" }}>
			<div style={{ flex: "1 1 100%", display: "flex", overflowY: "auto" }}>
				<Paper style={{ flex: 1, overflowY: "auto" }}>
					<Typography variant="h5" style={{ padding: "8px" }}>
						Broken Elevators
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								size="small"
								style={{ marginLeft: "8px" }}
								variant="inline"
								label="From Date"
								format="MM/dd/yyyy"
								value={fromDate}
								InputProps={{ disabled: true }}
								InputAdornmentProps={{ position: "start" }}
								onChange={(date) => {
									if (date.toString().includes("Invalid")) return;
									if (isNullOrEmpty(date)) return;
									setFromDate(date);
									getData(date, toDate);
								}}
							/>
							-
							<KeyboardDatePicker
								size="small"
								style={{ marginLeft: "8px" }}
								variant="inline"
								label="ToDate "
								format="MM/dd/yyyy"
								value={toDate}
								InputProps={{ disabled: true }}
								InputAdornmentProps={{ position: "start" }}
								onChange={(date) => {
									if (date.toString().includes("Invalid")) return;
									if (isNullOrEmpty(date)) return;
									setToDate(date);
									getData(fromDate, date);
								}}
							/>
						</MuiPickersUtilsProvider>
					</Typography>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Building</TableCell>
								<TableCell>Serial Number</TableCell>
								<TableCell>Callback Count</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{dataset.map((x: any, idx: Number) => {
								return (
									<TableRow key={idx.toString()}>
										<TableCell>{x.building_name}</TableCell>
										<TableCell>{x.serial_number}</TableCell>
										<TableCell>{x.callbacks}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</Paper>
			</div>
		</div>
	);
}
